import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';
import {
  PapiRequestSettingsUpdatePromotion,
  PapiSettingsUpdatePromotion,
} from '@wix/da-papi-types';

export const setPromotionalBannersWidgetDeviationPageBanner = createAction(
  `${reduxKey}.SET_PROMOTIONALBANNERS_WIDGET_DEVIATION_PAGE_BANNER`,
  (deviationPageBanner: boolean) => ({ deviationPageBanner })
);

export const setPromotionalBannersWidgetProfileCoverBanner = createAction(
  `${reduxKey}.SET_PROMOTIONALBANNERS_WIDGET_PROFILE_COVER_BANNER`,
  (profileCoverBanner: boolean) => ({ profileCoverBanner })
);

export const {
  submit: savePromotionalBanners,
  success: savePromotionalBannersSuccess,
  failure: savePromotionalBannersFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsUpdatePromotion, PapiSettingsUpdatePromotion>(
  reduxKey,
  'SAVE_PROMOTIONAL_BANNERS'
);
